import { IntlShape } from 'react-intl'
import { EventFilterTag } from '@/types/event'
import { formatTagName } from './formatTagName'

const getTagGroupConfig = (formatMessage: IntlShape['formatMessage']) => [
  {
    source: 'vp_agent_alert',
    label: formatMessage({ id: 'events.tags.group.alerts' })
  },
  {
    source: 'vp_agent',
    label: formatMessage({ id: 'events.tags.group.sceneTags' })
  }
]

export const buildTagFilterGroups = (
  tags: EventFilterTag[],
  formatMessage: IntlShape['formatMessage']
) => {
  const seen = new Set<string>()
  return getTagGroupConfig(formatMessage)
    .map(({ source, label }) => ({
      group: label,
      items: tags
        .filter(({ tag_source }) => tag_source === source)
        .flatMap(({ tag_name }) => {
          if (seen.has(tag_name)) return []
          seen.add(tag_name)
          return [{ value: tag_name, label: formatTagName(tag_name) }]
        })
    }))
    .filter(({ items }) => items.length > 0)
}
